import Request from './request';
import consts from "@/consts.js";

async function fetch (data) {
  return Request('get', 'api/sub-account-configs', data)
}

async function fetchAllForSelect(data) {
  if (!data) data = {};
  data.limit = consts.limitAll; //获取全部
  return Request('get', "api/sub-account-configs/select", data, false, false, true);
}

async function fetchOne (id) {
  // 获取单个
  return Request('get', 'api/sub-account-configs/view?id=' + id)
}

async function save (id, data) {
  // 编辑或新建数据（有id为编辑，没有id为新建）
  if (id) {
    return Request('post', 'api/sub-account-configs/edit?id=' + id, data)
  } else {
    return Request('post', 'api/sub-account-configs/add', data)
  }
}

async function del(id) {// 删除数据
  return Request('delete', "api/sub-account-configs/delete/" + id);
}

export default {
  fetch,
  fetchAllForSelect,
  fetchOne,
  save,
  del,
}
